require('offline-plugin/runtime').install();

import './index.html';
import './index.scss';
import './scripts/script.js';
